import { CreatePhotoMixInFromMediaName } from "@/utils/createPhotosFromMediaName";

import {
  SmallLadyResponseDTO,
  SmallLadyResponseDTORaw,
} from "../models/SmallLadyProfile.dto";

export const mapResponse = (
  response: SmallLadyResponseDTORaw,
): SmallLadyResponseDTO => {
  return {
    ...response,
    ladyDto: {
      ...response.ladyDto,
      photoSrcs: CreatePhotoMixInFromMediaName(
        response.ladyDto.mainPhotoDTO?.mediaName,
      ),
    },
  };
};
